import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { HOTEL } from "@/data/site";

export const FloatingWhatsApp = () => {
  const msg = encodeURIComponent("Hi Hotel Vijayshree Inn, I'd like to enquire about room availability.");
  const href = `https://wa.me/${HOTEL.whatsapp}?text=${msg}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.8, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-2xl pl-4 pr-5 py-3 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDuration: "2.5s" }} />
      <MessageCircle className="h-6 w-6 relative shrink-0 fill-white" />
      <span className="relative text-sm font-semibold hidden sm:inline">Chat with us</span>
    </motion.a>
  );
};
